import { Mail, Globe, MessageSquare } from "lucide-react";
import { Seo } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { ConsultationForm } from "@/components/ConsultationForm";
import { SITE } from "@/config/site";

export default function ContactPage() {
  return (
    <>
      <Seo
        title="Contact Us — Request a Consultation | Tedmo Services"
        description="Request a consultation with Tedmo Services. Tell us about your application, cloud, or infrastructure project and we will be in touch to discuss it."
        path="/contact"
      />

      <section className="py-20" data-testid="contact-section">
        <div className="max-w-6xl mx-auto px-6">
          <div className="max-w-3xl mb-14">
            <span className="font-mono-sub text-xs text-royal uppercase tracking-wider font-bold">
              Direct Engagement
            </span>
            <h1
              data-testid="contact-page-title"
              className="font-poster text-4xl sm:text-5xl font-extrabold text-steel mt-2 leading-tight"
            >
              Request a Consultation
            </h1>
            <p className="text-lg text-ink mt-6 leading-relaxed">
              Tell us about your project — a new application, a cloud migration,
              a server deployment, or ongoing support. We review every inquiry
              and get back to you to discuss next steps.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-start">
            <Reveal className="lg:col-span-2 space-y-4">
              <div className="bg-white rounded-xl border border-line p-6 shadow-sm">
                <div className="flex items-center gap-3 mb-2">
                  <Mail className="w-4 h-4 text-royal" aria-hidden="true" />
                  <span className="font-mono-sub text-xs text-mute uppercase tracking-wider">
                    Email
                  </span>
                </div>
                <a
                  href={`mailto:${SITE.email}`}
                  data-testid="contact-email-link"
                  className="font-poster font-bold text-steel hover:text-royal transition-colors"
                >
                  {SITE.email}
                </a>
              </div>
              <div className="bg-white rounded-xl border border-line p-6 shadow-sm">
                <div className="flex items-center gap-3 mb-2">
                  <Globe className="w-4 h-4 text-royal" aria-hidden="true" />
                  <span className="font-mono-sub text-xs text-mute uppercase tracking-wider">
                    Where we work
                  </span>
                </div>
                <p className="font-poster font-bold text-steel">Remote, worldwide</p>
                <p className="text-xs text-mute mt-1">
                  We serve businesses wherever they operate.
                </p>
              </div>
              <div className="bg-white rounded-xl border border-line p-6 shadow-sm">
                <div className="flex items-center gap-3 mb-2">
                  <MessageSquare className="w-4 h-4 text-royal" aria-hidden="true" />
                  <span className="font-mono-sub text-xs text-mute uppercase tracking-wider">
                    What happens next
                  </span>
                </div>
                <p className="text-xs text-ink leading-relaxed">
                  Your inquiry goes straight to our team. We review your project
                  description and reply to your business email to discuss your
                  project.
                </p>
              </div>
            </Reveal>

            <Reveal delay={100} className="lg:col-span-3">
              <ConsultationForm />
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
}
